import JsonForm from "../json-form/JsonForm";

export const routes = [
    {
        path: '/form/:token',
        component: JsonForm
    }
]